let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("zQCnS")).then(() => parcelRequire('4AYC5'));